export interface DonutChartWidgetPayload {
  donutChart?: {
    data: DonutChartWidgetData;
    config: DonutChartWidgetConfig;
  }
}

export interface DonutChartWidgetData {
  slices: DonutChartWidgetSliceData[];
}

export interface DonutChartWidgetSliceData {
  id: string;
  value: number;
}

export enum ChartStyle {
  CLASSIC = 'classic',
  RISK_MANAGEMENT = 'risk-management',
}

export interface DonutChartWidgetConfig {
  slices: DonutChartWidgetSliceConfig[];
  // text inside the chart donut
  label: string;
  infoBoxText?: string;
  // how to lay out the elements inside the chart tooltip
  tooltipType?: 'vertical' | 'horizontal';
  // which styles to use for the chart, see the component implementation for more info
  chartStyle?: ChartStyle;
  // if we should display tooltips on the chart & legend or not
  showTooltips?: boolean;
  // hovering over slices should do nothing
  disableSliceInteraction?: boolean;
  // legend on the side will be hidden
  hideLegend?: boolean;
  emptyStateColor?: string;
  chartSize?: number;
  // if set to the same value as chartSize, the chart label & value font sizes will not decrease
  chartSmallSize?: number;
  lineWidth?: number;
  // if the label inside the chart should span over multiple lines
  labelTextMultiline?: boolean;
}

export interface DonutChartWidgetSliceConfig {
  id: string;
  label: string;
  color: string;
}
